// 考试模式
export enum ExamModeEnum {
  /**
   * 每日打卡
   */
  PunchInDaily = 1,
  /**
   * 章节练习
   */
  ChapterPractice = 2,
  /**
   * 普通考试
   */
  NormalExam = 3,
  /**
   * 模拟考场
   */
  ImitateExam = 4,
  /**
   * 历年试题
   */
  PreviousExam = 5,
  /**
   * 错题本
   */
  WrongQuestion = 6,
  /**
   * 收藏夹
   */
  CollectionQuestion = 7,

  /**
   * 知识点练习
   */
  KnowledgeExam = 8,
}

// 作答模式
export enum AnswerModeEnum {
  /**
   * 默认模式
   */
  DefaultMode = 0,
  /**
   * 考试模式
   */
  NormalExamMode = 1,
  /**
   * 练习模式
   */
  PracticeMode = 2,
  /**
   * 机考模式
   */
  ComputerExamMode = 3,
  /**
   * 背题模式
   */
  RecitationMode = 4,
}

// 二次作答类型枚举
export enum SecondaryAnswerTypeEnum {
  Reset = '1',
  Continue = '2',
}

// 题目作答结果状态枚举
export enum QuestAnswerStatus {
  Undo = 0,
  Success = 1,
  Failed = 2,
  QuestSubjective = 3,
  WithFlag = 4,
}

// AI返回流式响应状态
export enum AiStreamStatus {
  /**
   * 响应成功
   */
  StreamingSuccess = 200,
}

export enum StreamsDataEnum {
  // 结束标志
  FINISH = 'finish',
}

export enum ConnectingTips {
  // 等待时的交互
  WAIT = 'AI内容生成中...',
  RECEIVE = 'Al助手生成的内容如下：',
}

// 异常返回信息
export enum AIStreamErrors {
  /**
   * 无权限
   */
  VerifyError = 'VerifyError',
  FrequencyError4 = 'FrequencyError4',
  FrequencyError30 = 'FrequencyError30',
}

export const AnswerModeTips = {
  [AnswerModeEnum.DefaultMode]: '',
  [AnswerModeEnum.NormalExamMode]: '考试模式：提交试卷后显示成绩与解析',
  [AnswerModeEnum.PracticeMode]: '练习模式：每答完一题立即显示答案和解析',
  [AnswerModeEnum.ComputerExamMode]: '机考模式：提交完后显示答案与解析',
  [AnswerModeEnum.RecitationMode]: '背题模式：直接显示答案解析',
};
